export default "__VITE_ASSET__292cb361__"